export default "__VITE_ASSET__2Uw2ATch__"